import { render, staticRenderFns } from "./SubscriptionPrescriber.vue?vue&type=template&id=1a220a3a&scoped=true&"
import script from "./SubscriptionPrescriber.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPrescriber.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionPrescriber.vue?vue&type=style&index=0&id=1a220a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a220a3a",
  null
  
)

export default component.exports